import { z } from 'zod';
import { BaseErrorSchema } from '../../shared/error.schema';
/**
 * Record Step Recording Activity (heartbeat) Request Schema
 * POST /api/v2/process-step-recording/:id/heartbeat
 *
 * Empty body: the server times the gap between heartbeats with its own clock so
 * the accumulated active time cannot be inflated by the client.
 */ export const RecordStepRecordingActivityRequestSchema = z.void();
/**
 * Record Step Recording Activity Response Schema
 * The controller returns 204 with no body — nothing is exposed per the
 * capture-and-store-only scope.
 */ export const RecordStepRecordingActivityResponseSchema = z.void();
export const RecordStepRecordingActivityErrorSchema = BaseErrorSchema;

//# sourceMappingURL=record-step-recording-activity.schema.js.map